export const CM_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const INTERNAL_DATE_FORMAT = 'DD/MM/YYYY';
